import { render, staticRenderFns } from "./TabellaPezziInsit.vue?vue&type=template&id=0d7ea4e0&"
import script from "./TabellaPezziInsit.vue?vue&type=script&lang=js&"
export * from "./TabellaPezziInsit.vue?vue&type=script&lang=js&"
import style0 from "./TabellaPezziInsit.vue?vue&type=style&index=0&id=0d7ea4e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports